<template>
  <p v-if="!enabledModulos.length" class="flow-text center">
    Você ainda não possui acesso a nenhum módulo.
  </p>
  <div v-else class="row-fix row">
    <div
      v-for="(item, index) in enabledModulos"
      v-bind:key="index"
      class="card-container col s12 m4 l3"
    >
      <a
        class="center"
        v-bind:title="`Acessar módulo ${item.title}`"
        tabindex="0"
        v-on:keyup.enter="onKeyup(item.actions)"
        v-on:click.prevent="onClick(item.actions)"
      >
        <BaseCard
          v-bind:is-hoverable="item.isHoverable"
          v-bind:disabled="item.disabled"
        >
          <template v-slot:card-content>
            <div class="modulo-logo valign-wrapper">
              <i
                v-if="!item.image"
                class="material-icons large"
                v-bind:class="[textColor, textLuminosity]"
                >{{ item.iconName }}</i
              >
              <img v-else class="responsive-img" v-bind="item.image" />
            </div>
            <div class="modulo-info-container">
              <span class="modulo-card-title">{{ item.cardTitle }}</span>
              <p class="grey-text text-darken-1">{{ item.content }}</p>
            </div>
          </template>
        </BaseCard>
      </a>
    </div>
  </div>
</template>

<script>
import { DEFAULT_COLOR, DEFAULT_LUMINOSITY } from "../constants";
import { ModuloService } from "../services";

export default {
  name: "TheModulosPanel",
  inheritAttrs: false,
  props: {
    title: String
  },
  data() {
    return {
      textColor: `${DEFAULT_COLOR}-text`,
      textLuminosity: DEFAULT_LUMINOSITY ? `text-${DEFAULT_LUMINOSITY}` : "",
      modulos: this.$store.state.modulos.map(item => ({
        ...ModuloService.mapToCard(item),
        iconName: item.iconName ? item.iconName : "account_balance",
        isHoverable: true,
        disabled: item.disabled,
        permission: item.permission
      }))
    };
  },
  computed: {
    enabledModulos() {
      return this.modulos.filter(item =>
        this.$authorization.hasPermission(item.permission)
      );
    }
  },
  methods: {
    accessModulo(actions) {
      if (!actions || !actions.length) {
        return;
      }

      this.$router.push(actions[0].to);
    },
    onClick(actions) {
      this.accessModulo(actions);
    },
    onKeyup(actions) {
      this.accessModulo(actions);
    }
  }
};
</script>

<style scoped>
.row-fix.row {
  display: flex;
  flex-wrap: wrap;
  align-content: stretch;
}

.row div.card-container {
  margin: 0.5rem 0 1rem 0;
  cursor: pointer;
  opacity: 0.7;
}

div.card-container:hover {
  opacity: 1;
}
.card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card /deep/ .card-content {
  padding: 14px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.card /deep/ .card-content .modulo-info-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card /deep/ .modulo-logo {
  justify-content: center;
  height: 144px;
}
.card /deep/ .modulo-card-title {
  display: block;
  font-size: 1.64rem;
  line-height: 110%;
  margin: 1.0933333333rem 0 0.656rem 0;
}
.card /deep/ img,
.card /deep/ i {
  max-height: 144px;
  margin: 0 auto;
}
.card /deep/ p {
  font-size: 18px;
  font-weight: 300;
}

/* Ajuste para aumentar a seletividade das regras de alto contraste */
.contrast .card /deep/ .modulo-logo i,
.contrast .card /deep/ .modulo-info-container p {
  color: white !important;
}
</style>
